import Header from './header';
import Footer from './footer';
import { useI18n } from './i18n';
import { PHONE_DISPLAY } from './phone';
import './App.css';

export default function ML() {
  const { t } = useI18n();
  return (
    <div className="os-page">
      <Header />
      <main className="os-main">
        <div className="os-pagehead">
          <span className="os-tab">{t('ml.tab')}</span>
          <h1 className="os-page-title">{t('ml.title')}</h1>
          <div className="os-dim90" aria-hidden="true">
            <span className="os-dim-line"></span>
            <span className="os-dim-label">90°</span>
            <span className="os-dim-line"></span>
          </div>
        </div>

        <section className="os-ml-plate" aria-labelledby="ml-societe">
          <h2 className="os-ml-plate-head" id="ml-societe">{t('ml.societe')}</h2>
          <div className="os-ml-body">
            OrtoSoft
            <br />
            SASU au capital de 2000€
            <br />
            22 rue Paul Henry THILLOY
            <br />
            92340 Bourg La Reine
            <br />
            <br />
            Contact : {PHONE_DISPLAY} / contact@ortosoft.fr
            <br />
            Directeur publication : Bogdan SCANTEIE
            <br />
            N° SIRET : 90439925000011 / RCS NANTERRE 904399250 / APE : 6201Z
            <br />
            N° TVA intracommunautaire : FR92 904399250
          </div>
        </section>

        <section className="os-ml-plate" aria-labelledby="ml-cookies">
          <h2 className="os-ml-plate-head" id="ml-cookies">{t('ml.cookies')}</h2>
          <div className="os-ml-body">
            Nous utilisons pas de cookies sur ce site.
            <br />
            Lors de la connexion à nos produits, nous utilisons des cookies de connexion.
            <p>En vous connectant vous acceptez l'utilisation de ces cookies.</p>
            <h4>Contenu embarqué depuis d'autres sites</h4>
            Les articles de ce site peuvent inclure des contenus intégrés (par exemple des vidéos, images, articles…). Le contenu intégré depuis d'autres sites se comporte de la même manière que si le visiteur se rendait sur cet autre site.
            <br />
            Ces sites web pourraient collecter des données sur vous, utiliser des cookies, embarquer des outils de suivis tiers, suivre vos interactions avec ces contenus embarqués si vous disposez d'un compte connecté sur leur site web.
            <br />
            <b>Ortosoft</b> vous informe qu'il n'exerce aucun contrôle sur le contenu de sites de tiers ou sur les pratiques de ces tiers en matière de protection des données à caractère personnel qu'ils pourraient recueillir.
            <br />
            En conséquence, <b>Ortosoft</b> décline toute responsabilité concernant le traitement par ces tiers de vos données à caractère personnel.
          </div>
        </section>

        <section className="os-ml-plate" aria-labelledby="ml-cgv">
          <h2 className="os-ml-plate-head" id="ml-cgv">{t('ml.cgv')}</h2>
          <div className="os-ml-body">
            <a href="cgv.pdf" target="_blank" rel="noreferrer">Conditions generales de vente</a>
          </div>
        </section>

        <section className="os-ml-plate" aria-labelledby="ml-hebergeur">
          <h2 className="os-ml-plate-head" id="ml-hebergeur">{t('ml.host')}</h2>
          <div className="os-ml-body">
            <a href="https://www.o2switch.fr/" target="_blank" rel="noreferrer">o2switch</a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
